import { useState, useEffect, useCallback } from "react";
import { db } from "./firebase";
import {
  collection, onSnapshot, addDoc, deleteDoc, doc,
  serverTimestamp, query, orderBy, updateDoc, increment, runTransaction
} from "firebase/firestore";

// ── стили ─────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Unbounded:wght@400;600;800&family=Manrope:wght@300;400;500;600&display=swap');
  :root {
    --bg:#0e0f11;--surface:#16181c;--card:#1e2128;--border:#2a2d35;
    --accent:#e8c547;--accent2:#4de0b0;--text:#f0f2f5;--muted:#7a8090;
    --danger:#e05252;--radius:12px;
  }
  *{box-sizing:border-box;margin:0;padding:0;}
  body{background:var(--bg);color:var(--text);font-family:'Manrope',sans-serif;}

  /* ── layout ── */
  .app{display:flex;min-height:100vh;}
  .sidebar{
    width:220px;flex-shrink:0;background:var(--surface);
    border-right:1px solid var(--border);display:flex;flex-direction:column;
    padding:24px 16px;position:sticky;top:0;height:100vh;z-index:10;
    transition:transform .25s;
  }
  .main{flex:1;padding:28px;overflow-y:auto;min-width:0;}

  /* ── mobile hamburger ── */
  .hamburger{
    display:none;position:fixed;top:14px;left:14px;z-index:200;
    background:var(--card);border:1px solid var(--border);border-radius:8px;
    padding:8px 10px;cursor:pointer;font-size:18px;color:var(--text);
  }
  .sidebar-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:9;}

  @media(max-width:768px){
    .hamburger{display:flex;align-items:center;justify-content:center;}
    .sidebar{
      position:fixed;top:0;left:0;height:100vh;transform:translateX(-100%);
      box-shadow:4px 0 24px rgba(0,0,0,.4);
    }
    .sidebar.open{transform:translateX(0);}
    .sidebar-overlay.open{display:block;}
    .main{padding:16px;padding-top:60px;}
    .page-title{font-size:16px;}
    .stats{flex-direction:column;gap:10px;}
    .stat-card{min-width:unset;}
    .form-row{flex-direction:column;gap:8px;}
    .form-group{min-width:unset!important;}
    .inv-line-wrap{flex-direction:column;}
    table{font-size:12px;}
    th,td{padding:8px 8px;}
    .btn-sm{padding:5px 9px;font-size:11px;}
    .modal{padding:16px;max-width:100%!important;border-radius:12px;}
    .modal-bg{padding:10px;align-items:flex-end;}
    .modal{border-radius:16px 16px 0 0;max-height:95vh!important;}
    .print-preview{padding:16px 14px!important;}
    .analytics-grid{grid-template-columns:1fr!important;}
    .date-row{flex-direction:column!important;gap:8px!important;}
  }

  .logo{font-family:'Unbounded',sans-serif;font-size:13px;font-weight:800;
    color:var(--accent);letter-spacing:.5px;margin-bottom:36px;line-height:1.4;}
  .logo span{display:block;color:var(--muted);font-size:10px;font-weight:400;margin-top:2px;}
  .nav-item{
    display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:8px;
    cursor:pointer;font-size:13.5px;font-weight:500;color:var(--muted);
    transition:all .2s;margin-bottom:4px;border:none;background:none;width:100%;text-align:left;
  }
  .nav-item:hover{color:var(--text);background:var(--card);}
  .nav-item.active{color:var(--accent);background:rgba(232,197,71,.1);}
  .nav-icon{font-size:16px;width:20px;text-align:center;}
  .page-title{font-family:'Unbounded',sans-serif;font-size:20px;font-weight:600;color:var(--text);margin-bottom:6px;}
  .page-sub{color:var(--muted);font-size:13px;margin-bottom:24px;}
  .card{background:var(--card);border:1px solid var(--border);border-radius:var(--radius);padding:20px;margin-bottom:16px;}
  .card-title{font-family:'Unbounded',sans-serif;font-size:12px;font-weight:600;color:var(--accent);letter-spacing:.5px;margin-bottom:16px;text-transform:uppercase;}
  .form-row{display:flex;gap:12px;flex-wrap:wrap;margin-bottom:12px;}
  .form-group{flex:1;min-width:180px;display:flex;flex-direction:column;gap:6px;}
  .form-group label{font-size:11px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.5px;}
  .form-group input,.form-group select{
    background:var(--surface);border:1px solid var(--border);border-radius:8px;
    padding:10px 12px;color:var(--text);font-family:'Manrope',sans-serif;font-size:14px;outline:none;transition:border-color .2s;
  }
  .form-group input:focus,.form-group select:focus{border-color:var(--accent);}
  .form-group select option{background:var(--surface);}
  .btn{padding:10px 20px;border-radius:8px;border:none;font-family:'Manrope',sans-serif;font-size:13px;font-weight:600;cursor:pointer;transition:all .2s;display:inline-flex;align-items:center;gap:6px;}
  .btn-primary{background:var(--accent);color:#0e0f11;}
  .btn-primary:hover{background:#f5d35a;transform:translateY(-1px);}
  .btn-primary:disabled{opacity:.5;transform:none;cursor:not-allowed;}
  .btn-secondary{background:var(--surface);color:var(--text);border:1px solid var(--border);}
  .btn-secondary:hover{border-color:var(--accent);color:var(--accent);}
  .btn-danger{background:rgba(224,82,82,.15);color:var(--danger);border:1px solid rgba(224,82,82,.3);}
  .btn-danger:hover{background:rgba(224,82,82,.25);}
  .btn-sm{padding:6px 12px;font-size:12px;}
  .btn-green{background:rgba(77,224,176,.15);color:var(--accent2);border:1px solid rgba(77,224,176,.3);}
  .btn-green:hover{background:rgba(77,224,176,.25);}
  .btn-warning{background:rgba(232,197,71,.15);color:var(--accent);border:1px solid rgba(232,197,71,.3);}
  .btn-warning:hover{background:rgba(232,197,71,.25);}
  .table-wrap{overflow-x:auto;-webkit-overflow-scrolling:touch;}
  table{width:100%;border-collapse:collapse;font-size:13.5px;}
  th{text-align:left;padding:10px 12px;color:var(--muted);font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.5px;border-bottom:1px solid var(--border);}
  td{padding:10px 12px;border-bottom:1px solid rgba(42,45,53,.6);vertical-align:middle;}
  tr:last-child td{border-bottom:none;}
  tr:hover td{background:rgba(255,255,255,.02);}
  .badge{display:inline-block;padding:2px 8px;border-radius:20px;font-size:11px;font-weight:600;}
  .badge-yellow{background:rgba(232,197,71,.15);color:var(--accent);}
  .badge-green{background:rgba(77,224,176,.15);color:var(--accent2);}
  .badge-red{background:rgba(224,82,82,.15);color:var(--danger);}
  .stats{display:flex;gap:16px;margin-bottom:24px;flex-wrap:wrap;}
  .stat-card{background:var(--card);border:1px solid var(--border);border-radius:var(--radius);padding:16px 20px;flex:1;min-width:140px;}
  .stat-label{font-size:11px;color:var(--muted);font-weight:600;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
  .stat-value{font-family:'Unbounded',sans-serif;font-size:22px;font-weight:600;color:var(--text);}
  .stat-value.accent{color:var(--accent);}
  .stat-value.green{color:var(--accent2);}
  .stat-value.red{color:var(--danger);}
  .inv-total{border-top:1px solid var(--border);margin-top:12px;padding-top:12px;text-align:right;font-family:'Unbounded',sans-serif;font-size:18px;color:var(--accent);}
  .inv-total span{font-size:12px;color:var(--muted);font-family:'Manrope',sans-serif;display:block;margin-bottom:2px;}
  .modal-bg{position:fixed;inset:0;background:rgba(0,0,0,.7);display:flex;align-items:center;justify-content:center;z-index:100;padding:20px;}
  .modal{background:var(--card);border:1px solid var(--border);border-radius:16px;padding:28px;width:100%;max-width:780px;max-height:90vh;overflow-y:auto;}
  .modal-title{font-family:'Unbounded',sans-serif;font-size:15px;font-weight:600;margin-bottom:20px;color:var(--text);}
  .print-preview{background:#fff;color:#000;border-radius:var(--radius);padding:28px 32px;font-family:Arial,sans-serif;font-size:13px;}
  .empty{text-align:center;padding:40px;color:var(--muted);}
  .empty-icon{font-size:36px;margin-bottom:8px;}
  .spinner{display:inline-block;width:18px;height:18px;border:2px solid var(--border);border-top-color:var(--accent);border-radius:50%;animation:spin .7s linear infinite;}
  @keyframes spin{to{transform:rotate(360deg);}}
  .toast{position:fixed;bottom:24px;right:24px;background:var(--card);border:1px solid var(--accent);border-radius:10px;padding:12px 20px;color:var(--accent);font-weight:600;font-size:13px;z-index:300;animation:fadeIn .3s;}
  .toast.error{border-color:var(--danger);color:var(--danger);}
  @keyframes fadeIn{from{opacity:0;transform:translateY(10px);}to{opacity:1;transform:translateY(0);}}
  .stock-warn{color:var(--danger);font-size:11px;margin-top:3px;}

  /* ── login full-screen ── */
  .login-wrap{
    min-height:100vh;
    display:flex;flex-direction:column;align-items:center;justify-content:space-between;
    background:#0e0f11;
    padding:56px 24px 44px;
    position:relative;
    overflow:hidden;
  }
  .login-wrap::before{
    content:'';position:absolute;top:-120px;left:50%;transform:translateX(-50%);
    width:500px;height:500px;border-radius:50%;
    background:radial-gradient(circle,rgba(232,197,71,.07) 0%,transparent 70%);
    pointer-events:none;
  }
  .login-top{display:flex;flex-direction:column;align-items:center;gap:0;position:relative;z-index:1;}
  .login-logo-wrap{display:flex;flex-direction:column;align-items:center;margin-bottom:0;}
  .login-logo{
    font-family:'Unbounded',sans-serif;font-size:24px;font-weight:800;
    color:#f0f2f5;letter-spacing:3px;
  }
  .login-logo-line{
    width:32px;height:3px;background:#e8c547;border-radius:2px;margin-top:7px;
  }
  .login-title{
    font-size:22px;font-weight:600;color:#f0f2f5;
    margin-top:36px;letter-spacing:.2px;text-align:center;
  }
  .pin-dots{display:flex;gap:20px;justify-content:center;margin-top:28px;}
  .pin-dot{
    width:13px;height:13px;border-radius:50%;
    background:rgba(255,255,255,.18);
    transition:background .15s,transform .15s;
  }
  .pin-dot.filled{background:#f0f2f5;transform:scale(1.1);}
  .pin-dot.error{background:#e05252;animation:dotShake .45s ease;}
  @keyframes dotShake{
    0%,100%{transform:translateX(0);}
    20%{transform:translateX(-6px);}
    40%{transform:translateX(6px);}
    60%{transform:translateX(-4px);}
    80%{transform:translateX(4px);}
  }
  .login-bottom{width:100%;max-width:300px;position:relative;z-index:1;}
  .pin-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;}
  .pin-key{
    width:100%;padding-top:100%;
    position:relative;
    border-radius:50%;border:none;
    background:rgba(255,255,255,.09);
    cursor:pointer;
    transition:background .12s,transform .1s;
    -webkit-tap-highlight-color:transparent;
    outline:none;
  }
  .pin-key-inner{
    position:absolute;inset:0;
    display:flex;align-items:center;justify-content:center;
    font-size:30px;font-weight:300;color:#f0f2f5;
    font-family:'Manrope',sans-serif;
    pointer-events:none;
    user-select:none;
  }
  .pin-key:hover{background:rgba(255,255,255,.15);}
  .pin-key:active{background:rgba(232,197,71,.22);transform:scale(.91);}
  .pin-key.del{background:transparent;}
  .pin-key.del:hover{background:rgba(255,255,255,.07);}
  .pin-key.del .pin-key-inner{font-size:24px;}
  .pin-key.empty-cell{background:transparent;cursor:default;pointer-events:none;}
  .login-hint{
    text-align:center;font-size:12px;color:rgba(255,255,255,.3);
    margin-top:24px;letter-spacing:.3px;
  }

  /* ── analytics ── */
  .analytics-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:16px;margin-top:20px;}
  .analytics-card{background:var(--card);border:1px solid var(--border);border-radius:var(--radius);padding:16px;}
  .analytics-product{font-weight:600;font-size:14px;margin-bottom:10px;color:var(--text);}
  .analytics-row{display:flex;justify-content:space-between;align-items:center;padding:5px 0;border-bottom:1px solid rgba(42,45,53,.4);font-size:13px;}
  .analytics-row:last-child{border-bottom:none;}
  .date-row{display:flex;gap:12px;align-items:flex-end;flex-wrap:wrap;margin-bottom:20px;}
  .bar{height:8px;border-radius:4px;margin-top:6px;}
  .bar-out{background:linear-gradient(90deg,var(--danger),#ff7070);}
  .bar-in{background:linear-gradient(90deg,var(--accent2),#80ffe8);}
`;

// ── утилиты ───────────────────────────────────────────────────────
const uid = () => Math.random().toString(36).slice(2, 9);
const fmt = (n) => Number(n).toLocaleString("ru-RU", {minimumFractionDigits:2,maximumFractionDigits:2});
const todayStr = () => new Date().toISOString().slice(0,10);
const CORRECT_PIN = "3568";

// ── сумма прописью ────────────────────────────────────────────────
function amountToWords(amount) {
  const n=Math.round(amount*100), rubles=Math.floor(n/100), kopecks=n%100;
  const ones=["","один","два","три","четыре","пять","шесть","семь","восемь","девять","десять","одиннадцать","двенадцать","тринадцать","четырнадцать","пятнадцать","шестнадцать","семнадцать","восемнадцать","девятнадцать"];
  const onesF=["","одна","две","три","четыре","пять","шесть","семь","восемь","девять","десять","одиннадцать","двенадцать","тринадцать","четырнадцать","пятнадцать","шестнадцать","семнадцать","восемнадцать","девятнадцать"];
  const tens=["","","двадцать","тридцать","сорок","пятьдесят","шестьдесят","семьдесят","восемьдесят","девяносто"];
  const hundreds=["","сто","двести","триста","четыреста","пятьсот","шестьсот","семьсот","восемьсот","девятьсот"];
  const decl=(n,f1,f2,f5)=>{const n10=n%100,n1=n%10;if(n10>=11&&n10<=19)return f5;if(n1===1)return f1;if(n1>=2&&n1<=4)return f2;return f5;};
  const triplet=(n,fem)=>{let s="";const h=Math.floor(n/100),t=Math.floor((n%100)/10)*10+(n%10);if(h)s+=hundreds[h]+" ";if(t<20){s+=(fem?onesF[t]:ones[t]);if(t)s+=" ";}else{s+=tens[Math.floor(t/10)]+" ";const o=t%10;if(o)s+=(fem?onesF[o]:ones[o])+" ";}return s;};
  let result="";
  const bil=Math.floor(rubles/1e9),mil=Math.floor((rubles%1e9)/1e6),tho=Math.floor((rubles%1e6)/1e3),rest=rubles%1e3;
  if(bil)result+=triplet(bil,false)+decl(bil%1000,"миллиард","миллиарда","миллиардов")+" ";
  if(mil)result+=triplet(mil,false)+decl(mil%1000,"миллион","миллиона","миллионов")+" ";
  if(tho)result+=triplet(tho,true)+decl(tho%1000,"тысяча","тысячи","тысяч")+" ";
  if(rest)result+=triplet(rest,false);
  if(!rubles)result="ноль ";
  result=result.trim();
  result=result.charAt(0).toUpperCase()+result.slice(1);
  result+=" "+decl(rubles%1000||(rubles===0?0:rubles),"рубль","рубля","рублей");
  result+=" "+String(kopecks).padStart(2,"0")+" "+decl(kopecks,"копейка","копейки","копеек");
  return result;
}

// ── Toast ─────────────────────────────────────────────────────────
function Toast({msg,error}){return msg?<div className={`toast${error?" error":""}`}>{error?"✕":"✓"} {msg}</div>:null;}

// ── хук Firestore ─────────────────────────────────────────────────
function useCollection(name) {
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(true);
  useEffect(()=>{
    const q=query(collection(db,name),orderBy("createdAt","desc"));
    const unsub=onSnapshot(q,snap=>{setData(snap.docs.map(d=>({id:d.id,...d.data()})));setLoading(false);},()=>setLoading(false));
    return unsub;
  },[name]);
  const add=async(item)=>await addDoc(collection(db,name),{...item,createdAt:serverTimestamp()});
  const remove=async(id)=>await deleteDoc(doc(db,name,id));
  const update=async(id,data)=>await updateDoc(doc(db,name,id),data);
  return{data,loading,add,remove,update};
}

// ── StockBadge ────────────────────────────────────────────────────
function StockBadge({stock}){
  const n=Number(stock)||0;
  if(n<=0)return<span className="badge badge-red">Нет</span>;
  if(n<=5)return<span className="badge badge-yellow">⚠ {n}</span>;
  return<span className="badge badge-green">{n}</span>;
}

// ── LoginScreen ───────────────────────────────────────────────────
function LoginScreen({onSuccess}){
  const [pin,setPin]=useState("");
  const [shake,setShake]=useState(false);
  const [hoveredKey,setHoveredKey]=useState(null);

  const press=(d)=>{
    if(shake)return;
    if(pin.length>=4)return;
    const next=pin+d;
    setPin(next);
    if(next.length===4){
      if(next===CORRECT_PIN){
        sessionStorage.setItem("inv_auth","1");
        setTimeout(onSuccess,300);
      } else {
        setShake(true);
        setTimeout(()=>{setPin("");setShake(false);},700);
      }
    }
  };
  const del=()=>{if(!shake)setPin(p=>p.slice(0,-1));};

  useEffect(()=>{
    const handler=(e)=>{
      if(e.key>="0"&&e.key<="9") press(e.key);
      else if(e.key==="Backspace"||e.key==="Delete") del();
    };
    window.addEventListener("keydown",handler);
    return()=>window.removeEventListener("keydown",handler);
  },[pin,shake]);

  const S={
    wrap:{
      minHeight:"100vh",display:"flex",flexDirection:"column",
      alignItems:"center",justifyContent:"space-between",
      background:"#0e0f11",padding:"64px 24px 48px",
      fontFamily:"'Manrope',sans-serif",
    },
    top:{display:"flex",flexDirection:"column",alignItems:"center"},
    logoText:{
      fontFamily:"'Unbounded',sans-serif",fontSize:26,fontWeight:800,
      color:"#f0f2f5",letterSpacing:4,margin:0,
    },
    logoLine:{width:34,height:3,background:"#e8c547",borderRadius:2,marginTop:8},
    title:{
      fontSize:22,fontWeight:600,color:"#f0f2f5",
      marginTop:40,letterSpacing:.3,textAlign:"center",
    },
    dots:{display:"flex",gap:22,justifyContent:"center",marginTop:32},
    dot:(filled,error)=>({
      width:13,height:13,borderRadius:"50%",
      background: error?"#e05252": filled?"#f0f2f5":"rgba(255,255,255,.18)",
      transition:"background .15s,transform .15s",
      transform: filled&&!error?"scale(1.1)":"scale(1)",
    }),
    bottom:{width:"100%",maxWidth:290},
    grid:{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14},
    key:(hov)=>({
      width:"100%",paddingTop:"100%",position:"relative",
      borderRadius:"50%",border:"none",cursor:"pointer",
      background: hov?"rgba(255,255,255,.16)":"rgba(255,255,255,.09)",
      transition:"background .12s,transform .1s",
      WebkitTapHighlightColor:"transparent",outline:"none",
    }),
    keyInner:{
      position:"absolute",inset:0,display:"flex",
      alignItems:"center",justifyContent:"center",
      fontSize:30,fontWeight:300,color:"#f0f2f5",
      fontFamily:"'Manrope',sans-serif",pointerEvents:"none",userSelect:"none",
    },
    delKey:(hov)=>({
      width:"100%",paddingTop:"100%",position:"relative",
      borderRadius:"50%",border:"none",cursor:"pointer",
      background: hov?"rgba(255,255,255,.08)":"transparent",
      transition:"background .12s",
      WebkitTapHighlightColor:"transparent",outline:"none",
    }),
    emptyKey:{
      width:"100%",paddingTop:"100%",position:"relative",
      background:"transparent",border:"none",pointerEvents:"none",
    },
    hint:{
      textAlign:"center",fontSize:12,
      color:"rgba(255,255,255,.3)",marginTop:22,letterSpacing:.3,
    },
  };

  return(
    <div style={S.wrap}>
      <div style={S.top}>
        <div>
          <div style={S.logoText}>НАКЛАДНЫЕ</div>
          <div style={S.logoLine}/>
        </div>
        <div style={S.title}>Введите код доступа</div>
        <div style={S.dots}>
          {[0,1,2,3].map(i=>(
            <div key={i} style={S.dot(pin.length>i, shake&&pin.length>i)}/>
          ))}
        </div>
      </div>

      <div style={S.bottom}>
        <div style={S.grid}>
          {[1,2,3,4,5,6,7,8,9].map(n=>(
            <button key={n}
              style={S.key(hoveredKey===n)}
              onMouseEnter={()=>setHoveredKey(n)}
              onMouseLeave={()=>setHoveredKey(null)}
              onClick={()=>press(String(n))}>
              <span style={S.keyInner}>{n}</span>
            </button>
          ))}
          <div style={S.emptyKey}/>
          <button
            style={S.key(hoveredKey===0)}
            onMouseEnter={()=>setHoveredKey(0)}
            onMouseLeave={()=>setHoveredKey(null)}
            onClick={()=>press("0")}>
            <span style={S.keyInner}>0</span>
          </button>
          <button
            style={S.delKey(hoveredKey==="del")}
            onMouseEnter={()=>setHoveredKey("del")}
            onMouseLeave={()=>setHoveredKey(null)}
            onClick={del}>
            <span style={{...S.keyInner,fontSize:24}}>⌫</span>
          </button>
        </div>
        <div style={S.hint}>Можно вводить с клавиатуры компьютера</div>
      </div>
    </div>
  );
}

// ── BuyersPage ────────────────────────────────────────────────────
function BuyersPage(){
  const{data:buyers,loading,add,remove}=useCollection("buyers");
  const empty={name:"",inn:"",address:"",phone:"",contact:""};
  const[form,setForm]=useState(empty);
  const[saving,setSaving]=useState(false);
  const[toast,setToast]=useState("");
  const set=k=>e=>setForm(f=>({...f,[k]:e.target.value}));
  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(""),2500);};
  const submit=async()=>{if(!form.name.trim())return;setSaving(true);await add(form);setForm(empty);setSaving(false);showToast("Покупатель добавлен");};
  return(
    <>
      <div className="page-title">Покупатели</div>
      <div className="page-sub">База организаций и физических лиц</div>
      <div className="card">
        <div className="card-title">+ Добавить покупателя</div>
        <div className="form-row">
          <div className="form-group"><label>Наименование *</label><input value={form.name} onChange={set("name")} placeholder='ООО «Пример»'/></div>
          <div className="form-group"><label>ИНН</label><input value={form.inn} onChange={set("inn")} placeholder="7700000000"/></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Адрес</label><input value={form.address} onChange={set("address")} placeholder="г. Москва, ул. Ленина, 1"/></div>
          <div className="form-group"><label>Телефон</label><input value={form.phone} onChange={set("phone")} placeholder="+7 (999) 000-00-00"/></div>
          <div className="form-group"><label>Контактное лицо</label><input value={form.contact} onChange={set("contact")} placeholder="Иванов И.И."/></div>
        </div>
        <button className="btn btn-primary" onClick={submit} disabled={saving}>{saving?<span className="spinner"/>:"Добавить покупателя"}</button>
      </div>
      <div className="card">
        <div className="card-title">Список покупателей ({buyers.length})</div>
        {loading?<div className="empty"><div className="spinner"/></div>:buyers.length===0?(
          <div className="empty"><div className="empty-icon">🏢</div>Покупатели ещё не добавлены</div>
        ):(
          <div className="table-wrap">
            <table>
              <thead><tr><th>Наименование</th><th>ИНН</th><th>Адрес</th><th>Телефон</th><th>Контакт</th><th></th></tr></thead>
              <tbody>{buyers.map(b=>(
                <tr key={b.id}>
                  <td><b>{b.name}</b></td><td>{b.inn||"—"}</td><td>{b.address||"—"}</td><td>{b.phone||"—"}</td><td>{b.contact||"—"}</td>
                  <td><button className="btn btn-danger btn-sm" onClick={()=>remove(b.id)}>✕</button></td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
      </div>
      <Toast msg={toast}/>
    </>
  );
}

// ── ConfirmModal ─────────────────────────────────────────────────
function ConfirmModal({text,onConfirm,onCancel}){
  return(
    <div className="modal-bg" onClick={onCancel}>
      <div className="modal" style={{maxWidth:380}} onClick={e=>e.stopPropagation()}>
        <div style={{fontSize:18,marginBottom:8}}>⚠️</div>
        <div className="modal-title" style={{marginBottom:12}}>{text}</div>
        <div style={{fontSize:13,color:"var(--muted)",marginBottom:24}}>Это действие нельзя отменить.</div>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <button className="btn btn-secondary" onClick={onCancel}>Отмена</button>
          <button className="btn btn-danger" onClick={onConfirm}>Удалить</button>
        </div>
      </div>
    </div>
  );
}

// ── ProductsPage ──────────────────────────────────────────────────
function ProductsPage(){
  const{data:products,loading,add,remove,update}=useCollection("products");
  const empty={name:"",unit:"шт",price:"",vat:"20",category:"",stock:""};
  const[form,setForm]=useState(empty);
  const[saving,setSaving]=useState(false);
  const[toast,setToast]=useState({msg:"",error:false});
  const[editRow,setEditRow]=useState({});
  const[confirmId,setConfirmId]=useState(null); // id товара для подтверждения удаления
  const[filterCat,setFilterCat]=useState(""); // фильтр по категории
  const[search,setSearch]=useState(""); // поиск по названию

  const set=k=>e=>setForm(f=>({...f,[k]:e.target.value}));
  const showToast=(msg,error=false)=>{setToast({msg,error});setTimeout(()=>setToast({msg:"",error:false}),2500);};

  const submit=async()=>{
    if(!form.name.trim()||!form.price)return;
    setSaving(true);
    await add({...form,stock:Number(form.stock)||0});
    setForm(empty);setSaving(false);showToast("Товар добавлен");
  };
  const startEdit=(p)=>setEditRow(r=>({...r,[p.id]:{name:p.name,category:p.category||"",unit:p.unit,price:p.price,vat:p.vat,stock:String(p.stock||0)}}));
  const cancelEdit=(id)=>setEditRow(r=>{const n={...r};delete n[id];return n;});
  const setField=(id,k,v)=>setEditRow(r=>({...r,[id]:{...r[id],[k]:v}}));
  const saveRow=async(id)=>{
    const d=editRow[id];
    await update(id,{name:d.name,category:d.category,unit:d.unit,price:d.price,vat:d.vat,stock:Number(d.stock)||0});
    cancelEdit(id);showToast("Товар обновлён");
  };
  const confirmDelete=async()=>{
    await remove(confirmId);
    setConfirmId(null);
    showToast("Товар удалён");
  };

  const low=products.filter(p=>Number(p.stock)<=5&&Number(p.stock)>0).length;
  const none=products.filter(p=>Number(p.stock)<=0).length;

  // уникальные категории
  const categories=[...new Set(products.map(p=>p.category||"").filter(Boolean))].sort();

  // фильтрованный список
  const visible=products.filter(p=>{
    const matchCat=!filterCat||(p.category||"")===(filterCat);
    const matchSearch=!search||p.name.toLowerCase().includes(search.toLowerCase());
    return matchCat&&matchSearch;
  });

  const inpStyle={width:"100%",padding:"4px 6px",background:"var(--surface)",border:"1px solid var(--accent)",borderRadius:6,color:"var(--text)",fontSize:12};
  const confirmProduct=products.find(p=>p.id===confirmId);

  return(
    <>
      <div className="page-title">Товары и услуги</div>
      <div className="page-sub">Справочник номенклатуры и складские остатки</div>
      {products.length>0&&(
        <div className="stats">
          <div className="stat-card"><div className="stat-label">Позиций</div><div className="stat-value accent">{products.length}</div></div>
          <div className="stat-card"><div className="stat-label">Заканчивается</div><div className="stat-value accent">{low}</div></div>
          <div className="stat-card"><div className="stat-label">Нет в наличии</div><div className="stat-value red">{none}</div></div>
        </div>
      )}
      <div className="card">
        <div className="card-title">+ Добавить товар / услугу</div>
        <div className="form-row">
          <div className="form-group" style={{flex:3}}><label>Наименование *</label><input value={form.name} onChange={set("name")} placeholder="Ноутбук ASUS VivoBook"/></div>
          <div className="form-group"><label>Категория</label><input value={form.category} onChange={set("category")} placeholder="Электроника" list="cat-list"/><datalist id="cat-list">{categories.map(c=><option key={c} value={c}/>)}</datalist></div>
        </div>
        <div className="form-row">
          <div className="form-group"><label>Единица</label>
            <select value={form.unit} onChange={set("unit")}>{["шт","кг","л","м","м²","м³","упак","комп","услуга"].map(u=><option key={u}>{u}</option>)}</select>
          </div>
          <div className="form-group"><label>Цена без НДС (₽) *</label><input type="number" value={form.price} onChange={set("price")} placeholder="0.00"/></div>
          <div className="form-group"><label>НДС %</label>
            <select value={form.vat} onChange={set("vat")}>{["0","10","20"].map(v=><option key={v}>{v}</option>)}</select>
          </div>
          <div className="form-group"><label>Начальный остаток</label><input type="number" min="0" value={form.stock} onChange={set("stock")} placeholder="0"/></div>
        </div>
        <button className="btn btn-primary" onClick={submit} disabled={saving}>{saving?<span className="spinner"/>:"Добавить в справочник"}</button>
      </div>
      <div className="card">
        {/* фильтры */}
        <div style={{display:"flex",gap:10,marginBottom:16,flexWrap:"wrap",alignItems:"center"}}>
          <div style={{flex:1,minWidth:160}}>
            <input
              value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="🔍 Поиск по названию..."
              style={{width:"100%",padding:"8px 12px",background:"var(--surface)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text)",fontSize:13,outline:"none"}}
            />
          </div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            <button
              className={`btn btn-sm ${!filterCat?"btn-primary":"btn-secondary"}`}
              onClick={()=>setFilterCat("")}>
              Все ({products.length})
            </button>
            {categories.map(c=>(
              <button
                key={c}
                className={`btn btn-sm ${filterCat===c?"btn-primary":"btn-secondary"}`}
                onClick={()=>setFilterCat(f=>f===c?"":c)}>
                {c} ({products.filter(p=>p.category===c).length})
              </button>
            ))}
          </div>
        </div>

        <div className="card-title">
          Справочник
          {(filterCat||search)
            ? <span style={{color:"var(--muted)",fontWeight:400,textTransform:"none",fontSize:11,marginLeft:8}}>показано {visible.length} из {products.length}</span>
            : <span style={{color:"var(--muted)",fontWeight:400,textTransform:"none",fontSize:11,marginLeft:8}}>({products.length})</span>
          }
        </div>

        {loading?<div className="empty"><div className="spinner"/></div>:visible.length===0?(
          <div className="empty"><div className="empty-icon">🔍</div>Ничего не найдено</div>
        ):(
          <div className="table-wrap">
            <table>
              <thead><tr><th>Наименование</th><th>Категория</th><th>Ед.</th><th>Цена (без НДС)</th><th>НДС</th><th>Цена с НДС</th><th>Остаток</th><th></th></tr></thead>
              <tbody>{visible.map(p=>{
                const withVat=Number(p.price)*(1+Number(p.vat)/100);
                const ed=editRow[p.id];
                if(ed) return(
                  <tr key={p.id} style={{background:"rgba(232,197,71,.04)"}}>
                    <td><input style={inpStyle} value={ed.name} onChange={e=>setField(p.id,"name",e.target.value)}/></td>
                    <td><input style={inpStyle} value={ed.category} onChange={e=>setField(p.id,"category",e.target.value)} list="cat-list"/></td>
                    <td><select style={{...inpStyle,width:70}} value={ed.unit} onChange={e=>setField(p.id,"unit",e.target.value)}>{["шт","кг","л","м","м²","м³","упак","комп","услуга"].map(u=><option key={u}>{u}</option>)}</select></td>
                    <td><input style={{...inpStyle,width:90}} type="number" value={ed.price} onChange={e=>setField(p.id,"price",e.target.value)}/></td>
                    <td><select style={{...inpStyle,width:60}} value={ed.vat} onChange={e=>setField(p.id,"vat",e.target.value)}>{["0","10","20"].map(v=><option key={v}>{v}</option>)}</select></td>
                    <td style={{color:"var(--muted)",fontSize:12}}>{fmt(Number(ed.price)*(1+Number(ed.vat)/100))} ₽</td>
                    <td><input style={{...inpStyle,width:70}} type="number" min="0" value={ed.stock} onChange={e=>setField(p.id,"stock",e.target.value)}/></td>
                    <td><div style={{display:"flex",gap:5}}>
                      <button className="btn btn-green btn-sm" onClick={()=>saveRow(p.id)}>✓</button>
                      <button className="btn btn-secondary btn-sm" onClick={()=>cancelEdit(p.id)}>✕</button>
                    </div></td>
                  </tr>
                );
                return(
                  <tr key={p.id}>
                    <td><b>{p.name}</b></td>
                    <td>{p.category?<span className="badge badge-gray" style={{background:"rgba(122,128,144,.15)",color:"var(--muted)"}}>{p.category}</span>:"—"}</td>
                    <td>{p.unit}</td>
                    <td>{fmt(p.price)} ₽</td>
                    <td><span className="badge badge-yellow">{p.vat}%</span></td>
                    <td><b>{fmt(withVat)} ₽</b></td>
                    <td><StockBadge stock={p.stock}/></td>
                    <td><div style={{display:"flex",gap:5}}>
                      <button className="btn btn-warning btn-sm" title="Редактировать" onClick={()=>startEdit(p)}>✏</button>
                      <button className="btn btn-danger btn-sm" onClick={()=>setConfirmId(p.id)}>✕</button>
                    </div></td>
                  </tr>
                );
              })}</tbody>
            </table>
          </div>
        )}
      </div>
      {confirmId&&<ConfirmModal
        text={`Удалить «${confirmProduct?.name}»?`}
        onConfirm={confirmDelete}
        onCancel={()=>setConfirmId(null)}
      />}
      <Toast msg={toast.msg} error={toast.error}/>
    </>
  );
}

// ── PrintModal ────────────────────────────────────────────────────
const thS=`border:1px solid #000;padding:5px 7px;text-align:center;font-weight:bold;`;
const tdS=(x="")=>`border:1px solid #000;padding:4px 7px;${x}`;

function PrintModal({invoice,onClose}){
  if(!invoice)return null;
  const{seller,buyer,lines,through,basis,grandTotal,num,date}=invoice;
  const invNum=num?num.replace("ТН-","").replace(/^0+/,""):"1";
  const dateStr=new Date(date).toLocaleDateString("ru-RU");
  const totalQty=lines.reduce((s,l)=>s+Number(l.qty||0),0);
  const words=amountToWords(grandTotal);
  const hasVat=lines.some(l=>Number(l.vat)>0);
  const printInvoice=()=>{
    const linesHtml=lines.map((l,i)=>{
      const price=Number(l.price)||0,qty=Number(l.qty)||0;
      const sum=price*qty*(1+Number(l.vat||0)/100);
      const pw=price*(1+Number(l.vat||0)/100);
      return`<tr><td style="${tdS("text-align:right")}">${i+1}</td><td style="${tdS()}">${l.name}</td><td style="${tdS("text-align:center")}">${l.unit}</td><td style="${tdS("text-align:right")}">${qty}</td><td style="${tdS("text-align:right")}">${fmt(pw)}</td><td style="${tdS("text-align:right")}">${fmt(sum)}</td></tr>`;
    }).join("");
    const html=`<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Накладная № ${invNum}</title>
<style>@page{size:A4 portrait;margin:15mm 15mm 15mm 20mm;}body{font-family:Arial,sans-serif;font-size:13px;color:#000;background:#fff;margin:0;padding:0;}table{width:100%;border-collapse:collapse;}</style>
</head><body>
<div style="margin-bottom:18px;line-height:2;">
  <div><b>Продавец:</b> ${seller.name||""}${seller.inn?", ИНН "+seller.inn:""}${seller.address?", "+seller.address:""}</div>
  <div><b>Покупатель:</b> ${buyer.name}${buyer.inn?", ИНН "+buyer.inn:""}${buyer.address?", "+buyer.address:""}</div>
  <div><b>Через кого:</b> ${through||""}</div><div><b>Основание:</b> ${basis||""}</div>
</div>
<div style="text-align:center;font-weight:bold;font-size:15px;margin-bottom:12px;">НАКЛАДНАЯ № ${invNum} от ${dateStr}</div>
<table style="margin-bottom:10px;"><thead><tr>
  <th style="${thS}width:32px">№</th><th style="${thS}">Наименование</th><th style="${thS}width:68px">Ед. изм.</th>
  <th style="${thS}width:60px">Кол-во</th><th style="${thS}width:90px">Цена</th><th style="${thS}width:90px">Сумма</th>
</tr></thead><tbody>${linesHtml}</tbody>
<tfoot><tr>
  <td style="${tdS("font-weight:bold;text-align:center")}" colspan="3">Итого:</td>
  <td style="${tdS("font-weight:bold;text-align:right")}">${totalQty}</td>
  <td style="${tdS()}"></td>
  <td style="${tdS("font-weight:bold;text-align:right")}">${fmt(grandTotal)}</td>
</tr></tfoot></table>
<div style="font-size:13px;margin-bottom:32px;">Сумма прописью: ${words}. ${hasVat?"":"Без НДС."}</div>
<div style="display:flex;justify-content:space-between;margin-top:40px;">
  <div>Отпустил <span style="display:inline-block;border-bottom:1px solid #000;width:200px;margin-left:8px;">&nbsp;</span></div>
  <div>Получил <span style="display:inline-block;border-bottom:1px solid #000;width:200px;margin-left:8px;">&nbsp;</span></div>
</div>
<script>window.onload=()=>{window.print();window.onafterprint=()=>window.close();}<\/script></body></html>`;
    const w=window.open("","_blank","width=900,height=700");w.document.write(html);w.document.close();
  };
  return(
    <div className="modal-bg" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal">
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:8}}>
          <div className="modal-title" style={{margin:0}}>Накладная № {invNum}</div>
          <div style={{display:"flex",gap:8}}>
            <button className="btn btn-green btn-sm" onClick={printInvoice}>🖨 Печать</button>
            <button className="btn btn-secondary btn-sm" onClick={onClose}>✕</button>
          </div>
        </div>
        <div className="print-preview">
          <div style={{marginBottom:18,lineHeight:1.9,fontSize:13}}>
            <div><b>Продавец:</b> {seller.name||""}{seller.inn?`, ИНН ${seller.inn}`:""}{seller.address?`, ${seller.address}`:""}</div>
            <div><b>Покупатель:</b> {buyer.name}{buyer.inn?`, ИНН ${buyer.inn}`:""}{buyer.address?`, ${buyer.address}`:""}</div>
            <div><b>Через кого:</b> {through||""}</div>
            <div><b>Основание:</b> {basis||""}</div>
          </div>
          <div style={{textAlign:"center",fontWeight:"bold",fontSize:15,marginBottom:12}}>НАКЛАДНАЯ № {invNum} от {dateStr}</div>
          <table style={{width:"100%",borderCollapse:"collapse",fontSize:13,marginBottom:10}}>
            <thead><tr>{["№","Наименование","Ед. изм.","Кол-во","Цена","Сумма"].map((h,i)=>(
              <th key={i} style={{border:"1px solid #000",padding:"5px 7px",textAlign:"center"}}>{h}</th>
            ))}</tr></thead>
            <tbody>{lines.map((l,i)=>{
              const price=Number(l.price)||0,qty=Number(l.qty)||0;
              const sum=price*qty*(1+Number(l.vat||0)/100),pw=price*(1+Number(l.vat||0)/100);
              return<tr key={i}>
                <td style={{border:"1px solid #000",padding:"4px 7px",textAlign:"right"}}>{i+1}</td>
                <td style={{border:"1px solid #000",padding:"4px 7px"}}>{l.name}</td>
                <td style={{border:"1px solid #000",padding:"4px 7px",textAlign:"center"}}>{l.unit}</td>
                <td style={{border:"1px solid #000",padding:"4px 7px",textAlign:"right"}}>{qty}</td>
                <td style={{border:"1px solid #000",padding:"4px 7px",textAlign:"right"}}>{fmt(pw)}</td>
                <td style={{border:"1px solid #000",padding:"4px 7px",textAlign:"right"}}>{fmt(sum)}</td>
              </tr>;
            })}</tbody>
            <tfoot><tr>
              <td style={{border:"1px solid #000",padding:"4px 7px",fontWeight:"bold",textAlign:"center"}} colSpan={3}>Итого:</td>
              <td style={{border:"1px solid #000",padding:"4px 7px",fontWeight:"bold",textAlign:"right"}}>{totalQty}</td>
              <td style={{border:"1px solid #000",padding:"4px 7px"}}></td>
              <td style={{border:"1px solid #000",padding:"4px 7px",fontWeight:"bold",textAlign:"right"}}>{fmt(grandTotal)}</td>
            </tr></tfoot>
          </table>
          <div style={{fontSize:13,marginBottom:24}}>Сумма прописью: {words}. {hasVat?"":"Без НДС."}</div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:36,gap:24,flexWrap:"wrap"}}>
            <div style={{display:"flex",alignItems:"flex-end",gap:12}}>
              <span>Отпустил</span><div style={{borderBottom:"1px solid #000",width:160,marginBottom:2}}></div>
            </div>
            <div style={{display:"flex",alignItems:"flex-end",gap:12}}>
              <span>Получил</span><div style={{borderBottom:"1px solid #000",width:160,marginBottom:2}}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── InvoiceBuilder ────────────────────────────────────────────────
function InvoiceBuilder({buyers,products,onCreated}){
  const[seller,setSeller]=useState({name:"",inn:"",address:"",bank:"",account:"",bik:""});
  const[buyerId,setBuyerId]=useState("");
  const[lines,setLines]=useState([{id:uid(),productId:"",qty:"1",price:"",vat:"20",name:"",unit:"шт"}]);
  const[through,setThrough]=useState("");
  const[basis,setBasis]=useState("");
  const[saving,setSaving]=useState(false);
  const[toast,setToast]=useState({msg:"",error:false});
  const setSeller_=k=>e=>setSeller(s=>({...s,[k]:e.target.value}));
  const showToast=(msg,error=false)=>{setToast({msg,error});setTimeout(()=>setToast({msg:"",error:false}),3000);};
  const addLine=()=>setLines(l=>[...l,{id:uid(),productId:"",qty:"1",price:"",vat:"20",name:"",unit:"шт"}]);
  const delLine=id=>setLines(l=>l.filter(x=>x.id!==id));
  const updateLine=(id,k,v)=>setLines(l=>l.map(x=>x.id===id?{...x,[k]:v}:x));

  const computedLines=lines.map(line=>{
    let name=line.name,unit=line.unit,price=line.price,vat=line.vat,stockLeft=null,productId=line.productId;
    if(line.productId){const p=products.find(x=>x.id===line.productId);if(p){name=p.name;unit=p.unit;price=p.price;vat=p.vat;stockLeft=Number(p.stock)||0;}}
    const p2=Number(price)||0,q=Number(line.qty)||0,v=Number(vat)||0;
    const subtotal=p2*q,vatAmt=subtotal*v/100,total=subtotal+vatAmt;
    const overStock=stockLeft!==null&&q>stockLeft;
    return{...line,name,unit,price,vat,subtotal,vatAmt,total,stockLeft,overStock,productId};
  });

  const grandTotal=computedLines.reduce((s,l)=>s+l.total,0);
  const grandVat=computedLines.reduce((s,l)=>s+l.vatAmt,0);
  const grandSub=computedLines.reduce((s,l)=>s+l.subtotal,0);
  const buyer=buyers.find(b=>b.id===buyerId);
  const hasOverStock=computedLines.some(l=>l.overStock);

  const build=async()=>{
    if(!buyer)return showToast("Выберите покупателя",true);
    if(computedLines.some(l=>!l.name))return showToast("Заполните все строки товаров",true);
    if(hasOverStock)return showToast("Недостаточно товара на складе!",true);
    setSaving(true);
    try{
      await runTransaction(db,async(transaction)=>{
        for(const line of computedLines){
          if(line.productId){
            const ref=doc(db,"products",line.productId);
            transaction.update(ref,{stock:increment(-Number(line.qty))});
          }
        }
        const invRef=doc(collection(db,"invoices"));
        transaction.set(invRef,{seller,buyer,lines:computedLines,through,basis,grandTotal,grandVat,grandSub,date:todayStr(),createdAt:serverTimestamp()});
      });
      setLines([{id:uid(),productId:"",qty:"1",price:"",vat:"20",name:"",unit:"шт"}]);
      setThrough("");setBasis("");
      showToast("Накладная создана! Остатки списаны.");
      setTimeout(onCreated,800);
    }catch(e){showToast("Ошибка при сохранении",true);}
    setSaving(false);
  };

  return(
    <>
      <div className="page-title">Создать накладную</div>
      <div className="page-sub">Заполните данные и сформируйте документ</div>
      <div className="card">
        <div className="card-title">Продавец</div>
        <div className="form-row">
          <div className="form-group" style={{flex:3}}><label>Наименование</label><input value={seller.name} onChange={setSeller_("name")} placeholder='ООО "Компания"'/></div>
          <div className="form-group"><label>ИНН</label><input value={seller.inn} onChange={setSeller_("inn")} placeholder="7700000000"/></div>
        </div>
        <div className="form-row">
          <div className="form-group" style={{flex:2}}><label>Адрес</label><input value={seller.address} onChange={setSeller_("address")} placeholder="г. Москва"/></div>
          <div className="form-group"><label>Банк</label><input value={seller.bank} onChange={setSeller_("bank")} placeholder='АО "Сбербанк"'/></div>
          <div className="form-group"><label>р/с</label><input value={seller.account} onChange={setSeller_("account")} placeholder="40702810…"/></div>
          <div className="form-group"><label>БИК</label><input value={seller.bik} onChange={setSeller_("bik")} placeholder="044525225"/></div>
        </div>
      </div>
      <div className="card">
        <div className="card-title">Покупатель</div>
        <div className="form-row">
          <div className="form-group">
            <label>Выбрать из базы</label>
            <select value={buyerId} onChange={e=>setBuyerId(e.target.value)}>
              <option value="">— выберите покупателя —</option>
              {buyers.map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
            </select>
          </div>
        </div>
        {buyer&&<div style={{fontSize:13,color:"var(--muted)",lineHeight:1.7}}>
          {buyer.inn&&<div>ИНН: <b style={{color:"var(--text)"}}>{buyer.inn}</b></div>}
          {buyer.address&&<div>Адрес: <b style={{color:"var(--text)"}}>{buyer.address}</b></div>}
        </div>}
      </div>
      <div className="card">
        <div className="card-title">Товары / услуги</div>
        {computedLines.map((line,i)=>(
          <div key={line.id} className="inv-line-wrap" style={{display:"flex",gap:8,alignItems:"flex-end",flexWrap:"wrap",marginBottom:12,paddingBottom:12,borderBottom:"1px solid var(--border)"}}>
            <div className="form-group" style={{flex:3,minWidth:160}}>
              <label>Из справочника</label>
              <select value={line.productId} onChange={e=>updateLine(line.id,"productId",e.target.value)}>
                <option value="">— или ввести вручную —</option>
                {products.map(p=><option key={p.id} value={p.id}>{p.name} {Number(p.stock)>0?`(${p.stock} шт.)`:"(нет)"}</option>)}
              </select>
            </div>
            {!line.productId&&<>
              <div className="form-group" style={{flex:2,minWidth:130}}><label>Наименование</label><input value={line.name} onChange={e=>updateLine(line.id,"name",e.target.value)} placeholder="Товар"/></div>
              <div className="form-group" style={{minWidth:70}}><label>Ед.</label>
                <select value={line.unit} onChange={e=>updateLine(line.id,"unit",e.target.value)}>{["шт","кг","л","м","м²","упак","услуга"].map(u=><option key={u}>{u}</option>)}</select>
              </div>
              <div className="form-group" style={{minWidth:100}}><label>Цена без НДС</label><input type="number" value={line.price} onChange={e=>updateLine(line.id,"price",e.target.value)} placeholder="0.00"/></div>
              <div className="form-group" style={{minWidth:70}}><label>НДС %</label>
                <select value={line.vat} onChange={e=>updateLine(line.id,"vat",e.target.value)}>{["0","10","20"].map(v=><option key={v}>{v}</option>)}</select>
              </div>
            </>}
            <div className="form-group" style={{minWidth:90}}>
              <label>Кол-во {line.stockLeft!==null&&<span style={{color:"var(--muted)",fontWeight:400,fontSize:10}}>/{line.stockLeft}ост.</span>}</label>
              <input type="number" min="0.001" step="1" value={line.qty} onChange={e=>updateLine(line.id,"qty",e.target.value)} style={line.overStock?{borderColor:"var(--danger)"}:{}}/>
              {line.overStock&&<div className="stock-warn">⚠ Превышает остаток</div>}
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8,paddingBottom:line.overStock?20:2}}>
              <div style={{fontSize:13,color:line.overStock?"var(--danger)":"var(--accent)",fontWeight:600,whiteSpace:"nowrap"}}>{fmt(line.total)} ₽</div>
              {computedLines.length>1&&<button className="btn btn-danger btn-sm" onClick={()=>delLine(line.id)}>✕</button>}
            </div>
          </div>
        ))}
        <button className="btn btn-secondary btn-sm" onClick={addLine}>+ Добавить строку</button>
        <div className="inv-total">
          <span>Без НДС: {fmt(grandSub)} ₽</span>
          <span>НДС: {fmt(grandVat)} ₽</span>
          Итого: {fmt(grandTotal)} ₽
        </div>
      </div>
      <div className="card">
        <div className="card-title">Дополнительно</div>
        <div className="form-row">
          <div className="form-group"><label>Через кого</label><input value={through} onChange={e=>setThrough(e.target.value)} placeholder="Водитель / экспедитор"/></div>
          <div className="form-group"><label>Основание</label><input value={basis} onChange={e=>setBasis(e.target.value)} placeholder="Договор № 123"/></div>
        </div>
      </div>
      <button className="btn btn-primary" style={{fontSize:15,padding:"14px 32px"}} onClick={build} disabled={saving||hasOverStock}>
        {saving?<><span className="spinner"/> Сохранение...</>:"✦ Сформировать накладную"}
      </button>
      {hasOverStock&&<div style={{marginTop:10,color:"var(--danger)",fontSize:13}}>⚠ Исправьте количество — превышены складские остатки</div>}
      <Toast msg={toast.msg} error={toast.error}/>
    </>
  );
}

// ── InvoicesPage ──────────────────────────────────────────────────
function InvoicesPage(){
  const{data:invoices,loading,remove}=useCollection("invoices");
  const[preview,setPreview]=useState(null);
  const total=invoices.reduce((s,i)=>s+(i.grandTotal||0),0);
  const numbered=[...invoices].reverse().map((inv,i)=>({...inv,num:`ТН-${String(i+1).padStart(4,"0")}`})).reverse();
  return(
    <>
      <div className="page-title">Накладные</div>
      <div className="page-sub">История сформированных документов</div>
      {invoices.length>0&&(
        <div className="stats">
          <div className="stat-card"><div className="stat-label">Всего накладных</div><div className="stat-value accent">{invoices.length}</div></div>
          <div className="stat-card"><div className="stat-label">Общая сумма</div><div className="stat-value">{fmt(total)} ₽</div></div>
        </div>
      )}
      <div className="card">
        <div className="card-title">Все документы</div>
        {loading?<div className="empty"><div className="spinner"/></div>:invoices.length===0?(
          <div className="empty"><div className="empty-icon">📄</div>Накладные ещё не созданы</div>
        ):(
          <div className="table-wrap">
            <table>
              <thead><tr><th>Номер</th><th>Дата</th><th>Покупатель</th><th>Позиций</th><th>Сумма</th><th>Действия</th></tr></thead>
              <tbody>{numbered.map(inv=>(
                <tr key={inv.id}>
                  <td><span className="badge badge-yellow">{inv.num}</span></td>
                  <td>{inv.date?new Date(inv.date).toLocaleDateString("ru-RU"):"—"}</td>
                  <td><b>{inv.buyer?.name}</b></td>
                  <td>{inv.lines?.length}</td>
                  <td><b>{fmt(inv.grandTotal)} ₽</b></td>
                  <td style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                    <button className="btn btn-green btn-sm" onClick={()=>setPreview(inv)}>👁 Просмотр</button>
                    <button className="btn btn-danger btn-sm" onClick={()=>remove(inv.id)}>✕</button>
                  </td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
      </div>
      {preview&&<PrintModal invoice={preview} onClose={()=>setPreview(null)}/>}
    </>
  );
}

// ── AnalyticsPage ─────────────────────────────────────────────────
function AnalyticsPage({products,invoices}){
  const firstDay=new Date();firstDay.setDate(1);
  const[from,setFrom]=useState(firstDay.toISOString().slice(0,10));
  const[to,setTo]=useState(todayStr());

  // фильтр накладных по периоду
  const filtered=invoices.filter(inv=>{
    if(!inv.date)return false;
    return inv.date>=from&&inv.date<=to;
  });

  // по каждому товару: сколько ушло (из накладных) + текущий остаток
  const stats={};
  filtered.forEach(inv=>{
    (inv.lines||[]).forEach(l=>{
      if(!l.productId)return;
      if(!stats[l.productId])stats[l.productId]={qty:0,sum:0};
      stats[l.productId].qty+=Number(l.qty)||0;
      stats[l.productId].sum+=Number(l.total)||0;
    });
  });

  // товары у которых есть движение в периоде
  const active=products.filter(p=>stats[p.id]);
  const totalOut=Object.values(stats).reduce((s,v)=>s+v.qty,0);
  const totalSum=filtered.reduce((s,inv)=>s+(inv.grandTotal||0),0);
  const maxQty=Math.max(1,...active.map(p=>stats[p.id]?.qty||0));

  // быстрые периоды
  const setPreset=(days)=>{
    const d=new Date();
    const f=new Date();f.setDate(d.getDate()-days);
    setFrom(f.toISOString().slice(0,10));
    setTo(d.toISOString().slice(0,10));
  };
  const setMonth=()=>{const d=new Date();d.setDate(1);setFrom(d.toISOString().slice(0,10));setTo(todayStr());};

  return(
    <>
      <div className="page-title">Аналитика</div>
      <div className="page-sub">Движение товаров за выбранный период</div>

      {/* период */}
      <div className="card">
        <div className="card-title">Период</div>
        <div className="date-row" style={{display:"flex",gap:12,alignItems:"flex-end",flexWrap:"wrap"}}>
          <div className="form-group" style={{minWidth:150,flex:"none"}}>
            <label>С</label><input type="date" value={from} onChange={e=>setFrom(e.target.value)}/>
          </div>
          <div className="form-group" style={{minWidth:150,flex:"none"}}>
            <label>По</label><input type="date" value={to} onChange={e=>setTo(e.target.value)}/>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button className="btn btn-secondary btn-sm" onClick={setMonth}>Этот месяц</button>
            <button className="btn btn-secondary btn-sm" onClick={()=>setPreset(7)}>7 дней</button>
            <button className="btn btn-secondary btn-sm" onClick={()=>setPreset(30)}>30 дней</button>
            <button className="btn btn-secondary btn-sm" onClick={()=>setPreset(90)}>90 дней</button>
          </div>
        </div>
      </div>

      {/* сводка */}
      <div className="stats">
        <div className="stat-card"><div className="stat-label">Накладных за период</div><div className="stat-value accent">{filtered.length}</div></div>
        <div className="stat-card"><div className="stat-label">Выручка</div><div className="stat-value green">{fmt(totalSum)} ₽</div></div>
        <div className="stat-card"><div className="stat-label">Продано единиц</div><div className="stat-value">{totalOut}</div></div>
        <div className="stat-card"><div className="stat-label">Активных позиций</div><div className="stat-value">{active.length}</div></div>
      </div>

      {/* по товарам */}
      {active.length===0?(
        <div className="empty"><div className="empty-icon">📊</div>За выбранный период движений нет</div>
      ):(
        <>
          <div className="card">
            <div className="card-title">Расход по товарам</div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Товар</th><th>Ед.</th><th>Продано (шт.)</th><th>Сумма</th><th>Остаток</th><th>График</th></tr></thead>
                <tbody>{active.sort((a,b)=>(stats[b.id]?.qty||0)-(stats[a.id]?.qty||0)).map(p=>{
                  const s=stats[p.id];
                  const pct=Math.round((s.qty/maxQty)*100);
                  return(
                    <tr key={p.id}>
                      <td><b>{p.name}</b>{p.category&&<div style={{fontSize:11,color:"var(--muted)"}}>{p.category}</div>}</td>
                      <td>{p.unit}</td>
                      <td><b style={{color:"var(--danger)"}}>{s.qty}</b></td>
                      <td><b>{fmt(s.sum)} ₽</b></td>
                      <td><StockBadge stock={p.stock}/></td>
                      <td style={{minWidth:100}}>
                        <div style={{background:"var(--border)",borderRadius:4,height:8,overflow:"hidden"}}>
                          <div className="bar bar-out" style={{width:`${pct}%`,height:"100%"}}/>
                        </div>
                      </td>
                    </tr>
                  );
                })}</tbody>
              </table>
            </div>
          </div>

          {/* детализация по накладным */}
          <div className="card">
            <div className="card-title">Накладные за период</div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Дата</th><th>Покупатель</th><th>Состав</th><th>Сумма</th></tr></thead>
                <tbody>{filtered.map((inv,i)=>(
                  <tr key={inv.id}>
                    <td>{new Date(inv.date).toLocaleDateString("ru-RU")}</td>
                    <td><b>{inv.buyer?.name}</b></td>
                    <td style={{fontSize:12,color:"var(--muted)"}}>{(inv.lines||[]).map(l=>`${l.name} × ${l.qty}`).join(", ")}</td>
                    <td><b>{fmt(inv.grandTotal)} ₽</b></td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
}

// ── Root App ──────────────────────────────────────────────────────
export default function App(){
  const[auth,setAuth]=useState(()=>sessionStorage.getItem("inv_auth")==="1");
  const[page,setPage]=useState("create");
  const[sidebarOpen,setSidebarOpen]=useState(false);
  const{data:buyers}=useCollection("buyers");
  const{data:products}=useCollection("products");
  const{data:invoices}=useCollection("invoices");

  const lowCount=products.filter(p=>Number(p.stock)<=5&&Number(p.stock)>0).length;
  const noneCount=products.filter(p=>Number(p.stock)<=0).length;

  const nav=[
    {id:"create",icon:"✦",label:"Создать накладную"},
    {id:"invoices",icon:"📄",label:"Накладные"},
    {id:"buyers",icon:"🏢",label:"Покупатели"},
    {id:"products",icon:"📦",label:"Товары"},
    {id:"analytics",icon:"📊",label:"Аналитика"},
  ];

  if(!auth)return<><style>{CSS}</style><LoginScreen onSuccess={()=>setAuth(true)}/></>;

  const goTo=(id)=>{setPage(id);setSidebarOpen(false);};

  return(
    <>
      <style>{CSS}</style>
      <button className="hamburger" onClick={()=>setSidebarOpen(o=>!o)}>☰</button>
      <div className={`sidebar-overlay${sidebarOpen?" open":""}`} onClick={()=>setSidebarOpen(false)}/>
      <div className="app">
        <aside className={`sidebar${sidebarOpen?" open":""}`}>
          <div className="logo">НАКЛАДНЫЕ<span>Система документооборота</span></div>
          {nav.map(n=>(
            <button key={n.id} className={`nav-item${page===n.id?" active":""}`} onClick={()=>goTo(n.id)}>
              <span className="nav-icon">{n.icon}</span>{n.label}
              {n.id==="products"&&(noneCount>0||lowCount>0)&&(
                <span style={{marginLeft:"auto",fontSize:10,background:"var(--danger)",color:"#fff",borderRadius:10,padding:"1px 6px"}}>{noneCount+lowCount}</span>
              )}
            </button>
          ))}
          <div style={{marginTop:"auto",fontSize:11,color:"var(--muted)",lineHeight:1.8}}>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}>
              <span style={{width:7,height:7,borderRadius:"50%",background:"#4de0b0",display:"inline-block"}}/>
              <span style={{color:"var(--accent2)",fontWeight:600}}>Firebase</span>
            </div>
            <div>Покупателей: <b style={{color:"var(--text)"}}>{buyers.length}</b></div>
            <div>Товаров: <b style={{color:"var(--text)"}}>{products.length}</b></div>
            <div>Накладных: <b style={{color:"var(--accent)"}}>{invoices.length}</b></div>
            {noneCount>0&&<div style={{color:"var(--danger)"}}>Нет: <b>{noneCount}</b></div>}
            {lowCount>0&&<div style={{color:"var(--accent)"}}>Мало: <b>{lowCount}</b></div>}
            <button className="btn btn-danger btn-sm" style={{marginTop:12,width:"100%"}} onClick={()=>{sessionStorage.removeItem("inv_auth");setAuth(false);}}>Выйти</button>
          </div>
        </aside>
        <main className="main">
          {page==="create"   &&<InvoiceBuilder buyers={buyers} products={products} onCreated={()=>setPage("invoices")}/>}
          {page==="invoices" &&<InvoicesPage/>}
          {page==="buyers"   &&<BuyersPage/>}
          {page==="products" &&<ProductsPage/>}
          {page==="analytics"&&<AnalyticsPage products={products} invoices={invoices}/>}
        </main>
      </div>
    </>
  );
}
